import React, { useEffect, useState } from 'react';
import { Table, Spin, Select } from 'antd';
import { Pie } from 'react-chartjs-2';
import { poblacionetnias } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const { Option } = Select;

const columns = [
  {
    title: 'Tipo de Población',
    dataIndex: 'tipo',
    key: 'tipo',
    className: 'filaP',

  },
  {
    title: 'Cantidad',
    dataIndex: 'cantidad',
    key: 'cantidad',
    className: 'filaP',

  },
  {
    title: 'Porcentaje',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
    className: 'filaP',

  },
];

const EtniasComponente = ({ municipioId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fuente, setFuente] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    if (municipioId) {
      fetchData();  
    }
  
  }, [municipioId, year]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await poblacionetnias(municipioId, year);
  
      const poblacionData = response.data[0];
      const {
        total_poblacion_indigena,
        porc_total_pobl_indig,
        total_poblacion_negro,
        porc_total_poblacion_negro,
        total_poblacion_rom,
        porc_total_poblacion_rom,
        total_poblacion_raizal,
        porc_total_poblacion_raizal,
        total_poblacion_palenq,
        porc_total_poblacion_palenq,
        total_poblacion,
        porc_total_poblacion,
        fuente,
        descripcion,
      } = poblacionData;

      setData([
        {
          key: '1',
          tipo: 'Población Indígena',
          cantidad: total_poblacion_indigena.toLocaleString(),
          porcentaje: `${porc_total_pobl_indig}%`,
        },
        {
          key: '2',
          tipo: 'Población Negra',
          cantidad: total_poblacion_negro.toLocaleString(),
          porcentaje: `${porc_total_poblacion_negro}%`,
        },
        {
          key: '3',
          tipo: 'Población Rom',
          cantidad: total_poblacion_rom.toLocaleString(),
          porcentaje: `${porc_total_poblacion_rom}%`,
        },
        {
          key: '4',
          tipo: 'Población Raizal',
          cantidad: total_poblacion_raizal.toLocaleString(),
          porcentaje: `${porc_total_poblacion_raizal}%`,
        },
        {
          key: '5',
          tipo: 'Población Palenquera',
          cantidad: total_poblacion_palenq.toLocaleString(),
          porcentaje: `${porc_total_poblacion_palenq}%`,
        },
        {
          key: '6',
          tipo: 'Población Total',
          cantidad: total_poblacion.toLocaleString(),
          porcentaje: `${porc_total_poblacion}%`,
        },
      ]);
      setFuente(fuente);
      setDescripcion(descripcion);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo las áreas', error);
      setLoading(false);
    }
  };

  const handleYearChange = (value) => {
    setYear(value);
  };

  if (loading) {
    return <Spin />;
  }

  const chartData = {
    labels: data.map(item => item.tipo),
    datasets: [
      {
        data: data.map(item => parseFloat(item.porcentaje)),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
        ],
      },
    ],
  };

  return (
    <div>
      <h1>1.4. Información poblacional por etnias</h1>
      <p>{descripcion}</p>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        title={() => `Población desagregada por etnia - ${year}`}
        footer={() => (
          <div>
            <p>{`Fuente: ${fuente}`}</p>
          </div>
        )}
      />
      
      <div className="chart-container">
        {chartData && <Pie data={chartData} />}
      </div>
    </div>
  );
};

export default EtniasComponente;
